var render = function render(_c,_vm){return _c('span',{staticClass:"bg-secondary text-white rounded-circle avatar"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }